import React from 'react';
import { connect } from 'react-redux';
import EmailNotValidated from 'account/components/email_not_validated';
import { resendValidationEmail } from 'common/ducks/user';

const mapStateToProps = ({user}) => ({
  user
})

export default connect(mapStateToProps, {
  resendValidationEmail
})(EmailNotValidated);



// WEBPACK FOOTER //
// ./account/containers/email_not_validated.jsx